import React from 'react';

import { ContentContainer } from '../contentComponents';
import { SectionContainer, SectionHeading } from '../sectionComponents';
import SliderFlex from '../SliderFlex';

import Connects from './Connects';

const hardCodedToggles = [
  {
    heading: 'Organize your queries',
    emoji: '🗄',
    content: 'Create a library of common queries for your company.',
    link: {
      text: 'Learn more',
      href: '/product/shared-queries/',
      asPath: '/product/shared-queries/',
    },
  },
  {
    heading: 'Search for anything',
    emoji: '🔍',
    content:
      'Save time by searching if anyone on your team has answered this question before.',
    link: {
      text: 'Learn more',
      href: '/product/search/',
      asPath: '/product/search/',
    },
  },
  {
    heading: 'Shared connections',
    emoji: '🔌',
    content:
      'Make it easy for your team to securely access the database, without hunting for credentials.',
    link: {
      text: 'Learn more',
      href: '/connections/',
      asPath: '/connections/',
    },
  },
];

const images = [
  [
    {
      src: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/landing/first-section/1-1.svg`,
      style: {
        top: 0,
        left: 0,
        transform: 'scale(0)',
      },
      animationOptions: {
        duration: 1000,
      },
    },
    {
      src: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/landing/first-section/1-2.svg`,
      style: {
        top: -62,
        left: -25,
        boxShadow: '0px 15px 30px rgba(0, 0, 0, 0.1)',
        borderRadius: '12px',
        transform: 'scale(0)',
      },
      animationOptions: {
        duration: 900,
      },
    },
  ],
  [
    {
      src: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/landing/first-section/3-1.svg`,
      style: {
        top: 0,
        left: 0,
        boxShadow: `0px 30px 30px rgba(0, 0, 0, 0.02), 0px 0px 8px rgba(0, 0, 0, 0.03), 0px 1px 0px rgba(0, 0, 0, 0.05)`,
        borderRadius: '12px',
        transform: 'scale(0)',
        border: '1px solid #f4f4f4',
      },
    },
    {
      src: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/landing/first-section/3-2.svg`,
      style: {
        top: 193,
        left: -25,
        boxShadow: '0px 15px 30px rgba(0, 0, 0, 0.1)',
        borderRadius: '12px',
        transform: 'scale(0)',
      },
    },
  ],
  [
    {
      src: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/landing/first-section/2-1.svg`,
      style: {
        top: 0,
        left: 25,
        boxShadow: `0px 30px 30px rgba(0, 0, 0, 0.02), 0px 0px 8px rgba(0, 0, 0, 0.03), 0px 1px 0px rgba(0, 0, 0, 0.05)`,
        borderRadius: '12px',
        border: '1px solid #f4f4f4',
        transform: 'scale(0)',
      },
    },
    {
      src: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/landing/first-section/2-2.svg`,
      style: {
        top: 94,
        left: 0,
        boxShadow: '0px 15px 30px rgba(0, 0, 0, 0.1)',
        borderRadius: '12px',
        border: '1px solid #f4f4f4',
        transform: 'scale(0)',
      },
    },
    {
      src: `${process.env.NEXT_PUBLIC_ASSET_HOST}/static/landing/first-section/2-3.svg`,
      style: {
        top: 188,
        left: 25,
        boxShadow: '0px 15px 30px rgba(0, 0, 0, 0.1)',
        borderRadius: '12px',
        border: '1px solid #f4f4f4',
        transform: 'scale(0)',
      },
    },
  ],
];

const FirstSection = ({ heading, toggles }) => {
  return (
    <SectionContainer>
      <SectionHeading
        number={1}
        text={heading || 'Collaborate on data with your team'}
        id="features"
      />
      {/* <SectionSubheading text="Find the information you need faster, save time & collaborate by using queries from others." /> */}
      <ContentContainer additionalStyles={{ paddingBottom: 0 }}>
        <SliderFlex toggles={toggles || hardCodedToggles} images={images} />
        <Connects />
      </ContentContainer>
    </SectionContainer>
  );
};

export default FirstSection;
